import { Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef } from '@angular/material/dialog';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { ContentPipe } from '../../models/content-pipe.model';
import { PipeFormat } from '../../models/pipe-format.type';
import { SurveyEditorService } from '../../services/survey-editor.service';

@Component({
  selector: 'empathy-question-pipe-picker',
  templateUrl: 'question-pipe-picker.component.html',
  styleUrls: ['./question-pipe-picker.component.scss', './_question-pipe-picker-theme.component.scss']
})
export class QuestionPipePickerComponent implements OnInit {
  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  addBlockLoopOption$ = signal(false);

  readonly loopOptionValue = '[loopOption]';

  activeQuestionId: string;
  activeQuestionType: QuestionType;
  cardSelected: string;
  formatSelected: PipeFormat = 'lowercase';
  filteredQuestions: Question[];
  pipeFormatOptions: { value: PipeFormat; text: string }[] = [
    { value: 'lowercase', text: 'Lowercase' },
    { value: 'uppercase', text: 'Uppercase' },
    { value: 'capitalize', text: 'Capitalize' },
    { value: 'initial', text: 'As Configured' }
  ];
  questionType = QuestionType;
  rankSelected: string;
  selectedQuestion: Question;

  private previousQuestions: Question[] = [];
  private surveyEditorService = inject(SurveyEditorService);

  constructor(private dialogRef: MatDialogRef<QuestionPipePickerComponent, ContentPipe>) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-pipe-picker__dialog');

    this.activeQuestionId = this.surveyEditorService.surveyEditor$().activeQuestion.get('id').value;
    this.activeQuestionType = this.surveyEditorService.surveyEditor$().activeQuestion.get('type').value;
    this.previousQuestions = this.surveyEditorService.surveyEditor$().previousSelectableQuestions;
    this.filteredQuestions = this.previousQuestions.slice();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onComplete(): void {
    if (this.isValid()) {
      const rankId = this.rankSelected ? `rank_${this.rankSelected.split('_')[1]}` : '';
      this.dialogRef.close({
        qId: this.selectedQuestion.code,
        cardId: this.cardSelected,
        rankId,
        format: this.formatSelected,
        loopOption: this.addBlockLoopOption$()
      });
    } else if (this.addBlockLoopOption$()) {
      this.dialogRef.close({ qId: '', cardId: '', rankId: '', format: 'initial', loopOption: this.addBlockLoopOption$() });
    }
  }

  onQuestionSelected(event: MatAutocompleteSelectedEvent): void {
    if (event.option.value === this.loopOptionValue) {
      this.addBlockLoopOption$.set(true);
      this.selectedQuestion = null;
    } else {
      this.addBlockLoopOption$.set(false);
      this.selectedQuestion = this.filteredQuestions.find((q) => q.code === event.option.value);
    }
  }

  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredQuestions = this.previousQuestions.filter(
      (question) => question.id.toLowerCase().includes(filterValue) || question.title.toLowerCase().includes(filterValue)
    );
  }

  private isValid(): boolean {
    if (!this.selectedQuestion) {
      return false;
    }

    if (this.selectedQuestion.cards?.length > 0 && !this.cardSelected) {
      return false;
    }

    return true;
  }
}
